var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8662",
    "data-name": "Group 8662",
    transform: "translate(6992 -17596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3736",
    "data-name": "Rectangle 3736",
    transform: "translate(-6992 17596)",
    fill: "none",
    stroke: "#aeb0b3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 36,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 35,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8659",
    "data-name": "Group 8659",
    transform: "translate(-6980 17604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master_Card_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master_Card"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Red_x5F_Circle",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#f93232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Yellow_x5F_Circle",
    d: "M22,0a9.936,9.936,0,0,0-5.98,2H16v.014A10.06,10.06,0,0,0,14.893,3h2.214a9.7,9.7,0,0,1,.855,1H14.03a9.932,9.932,0,0,0-.667,1h5.264a10.27,10.27,0,0,1,.518,1H12.854a9.833,9.833,0,0,0-.377,1h7.044c.1.326.186.661.258,1H12.216a9.917,9.917,0,0,0-.157,1H19.94A8.457,8.457,0,0,1,20,10H12a10,10,0,0,0,.06,1h7.882c-.038.339-.093.672-.162,1H12.217a9.779,9.779,0,0,0,.261,1h7.044a9.832,9.832,0,0,1-.377,1H12.854a9.779,9.779,0,0,0,.509,1h5.264a9.782,9.782,0,0,1-.669,1H14.03a10.023,10.023,0,0,0,.862,1h2.215A10.049,10.049,0,0,1,16,17.986,10,10,0,1,0,22,0Z",
    fill: "#fed049"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardIcon);
export default __webpack_public_path__ + "static/media/master-card-icon.8b0399f740954ed892d82538be69f10e.svg";
export { ForwardRef as ReactComponent };